import { render } from "./RemovePatient.vue?vue&type=template&id=7b6e427c"
import script from "./RemovePatient.vue?vue&type=script&lang=js"
export * from "./RemovePatient.vue?vue&type=script&lang=js"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__